var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag",class:{ selected: _vm.isSelected }},[_c('span',{staticClass:"svg",domProps:{"innerHTML":_vm._s(_vm.svgData)}}),_c('span',[_vm._v(_vm._s(_vm.$t(("tags." + (_vm.tag._id) + ".name"))))])])}
var staticRenderFns = []

export { render, staticRenderFns }